import { ApplicationState, Dispatch } from 'application/redux';
import { add, remove } from 'core/spinner/redux/actions';
import { addToaster } from 'core/toaster/redux/actions';
import { ToasterType } from 'core/toaster/redux/types';
import { TimelineItem } from 'modules/operational/device/detail/dvr/redux/types';
import { MultipleSearchFilter } from '../components/MultipleSearch/types';
import { fetchAssociatedDevices, fetchNpvrInfo, fetchTimelineRecordings } from './services';
import {
  NPVR_HOUSEHOLD_DEVICES,
  NPVR_INFO,
  NPVR_TIMELINE_RECORDINGS,
  NpvrActions,
  NpvrDevicesResponse,
  NpvrInfoResponse,
  NpvrPayload
} from './types';

function success(payload: NpvrInfoResponse): NpvrPayload {
  return {
    type: NpvrActions.setNpvrInfo,
    payload,
  };
}

function getTimelineSuccess(payload: Array<TimelineItem>): NpvrPayload {
  return {
    type: NpvrActions.setTimelineInfo,
    payload,
  };
}

function getHouseholdDevicesSuccess(payload: NpvrDevicesResponse): NpvrPayload {
  return {
    type: NpvrActions.setDevicesInfo,
    payload,
  };
}

export function clearCacheNpvr(): NpvrPayload {
  return {
    type: NpvrActions.clearNpvrInfo,
  };
}

export type NpvrFilterAndPagination = {
  filter?: MultipleSearchFilter
  pagination?: {pageNumber: number, pageSize: number}
}

export function fetch(hhid: string, {filter, pagination}: NpvrFilterAndPagination) {
  return async (dispatch: Function, getState: () => ApplicationState) => {
    try {
      dispatch(add(NPVR_INFO, {}));
      const { data } = await fetchNpvrInfo(hhid, { filter, pagination })
      dispatch(success(data));
    } catch(error) {
      dispatch(addToaster({
        title: 'home.icon_npvr',
        message: 'error_messages.VIPOC_ERROR_021',
        type: ToasterType.danger,
      }));
    } finally {
      dispatch(remove(NPVR_INFO));
    }
  };
}

export function getTimelineRecordings({ hhid, deviceId }: { hhid: string, deviceId: string }) {
  return async (dispatch: Function, getState: () => ApplicationState) => {
    try {
      dispatch(add(NPVR_TIMELINE_RECORDINGS, {}));
      const { data } = await fetchTimelineRecordings(hhid, deviceId)
      dispatch(getTimelineSuccess(data));
    } catch(error) {
      dispatch(addToaster({
        title: 'home.icon_npvr',
        message: 'error_messages.VIPOC_ERROR_021',
        type: ToasterType.danger,
      }));
    } finally {
      dispatch(remove(NPVR_TIMELINE_RECORDINGS));
    }
  };
}

export function getAssociatedDevices(hhid: string) {
  return async (dispatch: Function, getState: () => ApplicationState) => {
    try {
      dispatch(add(NPVR_HOUSEHOLD_DEVICES, {}));
      const { data } = await fetchAssociatedDevices(hhid)
      dispatch(getHouseholdDevicesSuccess({ devices: data.devices, t: getState().i18n.t }));
    } catch(error: any) {
      if(error.status !== 404){
        dispatch(addToaster({
          title: 'home.icon_npvr',
          message: 'error_messages.VIPOC_ERROR_021',
          type: ToasterType.danger,
        }));
    }
    } finally {
      dispatch(remove(NPVR_HOUSEHOLD_DEVICES));
    }
  };
}

export function clearCachedNpvr() {
  return (dispatch: Dispatch) => {
    return dispatch(clearCacheNpvr())
  }
}